<script setup lang="ts">
const value = defineModel<string>('value', {
  default: '',
  required: true,
});

defineProps({
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    required: false,
  },
  maxLength: {
    type: Number,
    required: false,
  },
  placeholder: {
    type: String,
    required: true,
  },
  additionalClasses: {
    type: String,
    required: false,
  },
  mask: {
    type: String,
    required: false,
    default: '',
  },
});

const randomId = `input-${Math.random().toString(36).substr(2, 9)}`;
</script>
<template>
  <y-input-wrapper v-bind:max-length="maxLength ?? 0">
    <label slot="label" :for="randomId">{{ label }}</label>
    <input
      :id="randomId"
      v-model="value"
      :required="required"
      :class="['order-form__input-text', additionalClasses].join(' ')"
      :placeholder="placeholder"
      v-maska="mask"
      autocomplete="off"
    />
  </y-input-wrapper>
</template>
